<template>
  <vacancy-videointerview-navigation v-if="allow_vi_question_random" />

  <router-view v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import VacancyVideointerviewNavigation from './navigation';

export default {
  name: 'VacancyVideointerviewView',

  components: {
    VacancyVideointerviewNavigation
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.getters['vacancy_new/modules/allow_video'] === false) {
        next({ name: 'vacancy_basic' });
      }
    });
  },

  computed: {
    ...mapGetters('vacancy_new/modules', ['allow_vi_question_random'])
  },

  beforeDestroy() {
    this.$store.commit('vacancy/videointerview/clear');
  }
};
</script>
